import React from "react";

export default () => (
  <section id="education">
    <div className="section_left">
      <div className="section_hexagon" />
      <picture>
        <source srcSet="images/education/img.webp" type="image/webp" />
        <img className="image" src="images/education/img.jpg" alt="true" />
      </picture>
    </div>
    <div className="section_right">
      <div className="section_title">
        <p>EDUCATION</p>
        <h2>教育制度</h2>
      </div>
      <div className="section_contents">
        <p className="title">
          新入社員研修、各職種の基礎講座、PM研修、<br />マネジメント勉強会、外部講師研修（不定期で開催）、<br />ラーニングエージェンシー（外部研修 ※旧トーマツ）
        </p>
        <p className="text">
          より実践に近い研修をLYZONオリジナルで行っているので、<br className="d-none d-lg-inline" />その後の業務に活かすことができます。<br />また、研修内容は動画でも確認できるため<br className="d-none d-lg-inline" />自己学習にも役立ちます。
        </p>
      </div>
    </div>
  </section>
)



// WEBPACK FOOTER //
// ./src/Home/Education.js